import "./mainbanner.scss"
import { Box, Grid, Button, Typography } from "@mui/material";

import pluginHero from "../../../static/images/distant_bass_suite/plugin-hero.webp"
import pluginHeroSmall from "../../../static/images/distant_bass_suite/plugin-hero-800.webp"
import heroBackground from "../../../static/images/distant_bass_suite/hero-background.webp"

import { useEffect, useState } from "react";
import BuyButton from "../../BuyButton";
import PriceComponent from "../../PriceComponents";

const Image = () => {
  return <img
    loading="eager"
    decoding="async"
    alt="BassSuite - Distant plugin interface showing the Skinscraper amplifier"
    src={pluginHero}
    srcSet={`${pluginHeroSmall} 800w, ${pluginHero} 1600w`}
    sizes="(min-width: 816px) 800px, calc(100vw - 16px)"
    width={1600}
    height={1079}
    style={{ width: "100%", height: "auto", maxWidth: "800px" }}
  />
}

const MainBanner = ({ price, product, onTrial }) => {

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < window.innerHeight
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  return (
    <Box
      sx={{
        backgroundImage: `url(${heroBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        p: 0,
        m: 0,
        flex: 100,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: { xs: "block", md: "flex" },
        flexDirection: "column",
        minHeight: "100vh",
        // maxHeight: "calc(100vh)",
      }}
    >
      <div
        style={{
          zIndex: 0,
          position: "absolute",
          pointerEvents: "none",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.0) 0%, #000 95%)",
        }}
      ></div>
      {/* 
      <Box sx={{
        position: "absolute",
        fontSize: 50,
        color: "white",
        href: "#ampBanner",
        variant: "outlined",
        bottom: { xs: 160, md: 80 },
        left: 0,
        right: 0,
        mr: "auto",
        ml: "auto",

      }}
      >
        <IconButton
          href="#ampBanner"
          sx={{
            color: "white",
          }}
        >
          <ExpandMoreIcon sx={{ fontSize: 50 }} />
        </IconButton>
      </Box> */}

      <Grid container justifyContent={"center"} className="fadeIn">
        <Grid xs={12} md={10} sx={{ background: "none", p: 1, borderRadius: 10, }}>
          <Image />
          {/* <Box sx={{ minHeight: "100vh" }} /> */}
          <Typography
            variant="h2"
            fontSize={30}
            sx={{ fontSize: 30, }}
          >
            BassSuite - Distant
          </Typography>
          <Typography
            // fontFamily={"pirulen"}
            style={{
              fontSize: state.mobileView ? "20px" : "30px",
              // fontWeight: 500,
            }}
          >
            <i>Extreme. Unapologetic. BASS.</i>
          </Typography>

          <PriceComponent product={product} />
          <Box sx={{ mt: 3, columnGap: 5, rowGap: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "center", alignItems: "center" }}>
            <Button
              sx={{ width: { xs: "75%", md: "150px", background: "rgba(36, 36, 36, 0.5)" } }}
              variant="outlined"
              onClick={() => {
                const element = document.getElementById("overview");
                if (element) {
                  let y = element?.getBoundingClientRect()?.top + window.pageYOffset - 64;
                  window.scrollTo({ top: y, behavior: 'smooth' });
                }
              }}
            >
              Learn More
            </Button>
            <Button
              variant="outlined"
              onClick={onTrial}
              sx={{ width: { xs: "75%", md: "150px", background: "rgba(36, 36, 36, 0.5)" } }}
            >
              Free Trial
            </Button>
            <BuyButton color="primary" variant="contained" product={product} sx={{ width: { xs: "75%", md: "150px" } }} />
          </Box>
        </Grid>
      </Grid>
    </Box >
  );
};

export default MainBanner;
